import { SDKResponse } from '@commercetools/frontend-sdk';

export const extractDataFromSdkResponse = <T>(response: SDKResponse<T>): T => {
  if (response.isError) {
    const error = response.error.message;
    throw new Error(error);
  }
  return response.data;
};
